import React, { useEffect, useState } from 'react';
import MusteriSoruKarti from './MusteriSoruKarti';

export const DURUM_ETIKET = {
  beklemede: { ad: 'Beklemede', sinif: 'bg-amber-100 text-amber-800' },
  islendi: { ad: 'İşlendi', sinif: 'bg-green-100 text-green-800' },
  iptal: { ad: 'İptal', sinif: 'bg-gray-200 text-gray-600' },
};

/** Numara listesini panoya yazar; tarayıcı izin vermezse metni seçilebilir kutuda bırakır. */
export async function numaraKopyala(nolar) {
  const metin = nolar.join(', ');
  try { await navigator.clipboard.writeText(metin); return true; } catch { return false; }
}

const tarih = (t) => (t ? new Date(t).toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' }) : '');

/** Müşterinin kendi siparişleri: numara listesi (Kopyala), durum, ayrıntıda soruların kendisi. */
export default function MusteriSiparisler({ api, vurgu = null }) {
  const [liste, setListe] = useState(null);
  const [hata, setHata] = useState('');
  const [acik, setAcik] = useState(null);       // { id, sorular }
  const [kopyalandi, setKopyalandi] = useState(null);

  useEffect(() => {
    let iptal = false;
    api.siparisler()
      .then((d) => { if (!iptal) setListe(d.siparisler || []); })
      .catch((e) => { if (!iptal) { setHata(e.message || 'Siparişler alınamadı'); setListe([]); } });
    return () => { iptal = true; };
  }, [api]);

  const ac = async (s) => {
    if (acik && acik.id === s.id) { setAcik(null); return; }
    setAcik({ id: s.id, sorular: null });
    try { const d = await api.siparis(s.id); setAcik({ id: s.id, sorular: d.sorular || [] }); } catch (e) { setAcik({ id: s.id, sorular: [], hata: e.message }); }
  };
  const kopyala = async (s) => { if (await numaraKopyala(s.numaralar)) { setKopyalandi(s.id); setTimeout(() => setKopyalandi(null), 2000); } };

  if (liste === null) return <div className="py-8 text-center text-sm text-gray-400">Siparişler yükleniyor…</div>;
  return (
    <div className="space-y-3">
      {hata && <div className="p-3 rounded-lg border border-red-300 bg-red-50 text-sm text-red-700">{hata}</div>}
      {liste.length === 0 && !hata && (
        <div className="p-8 text-center text-sm text-gray-500 bg-white rounded-xl border border-gray-200">Henüz siparişiniz yok.</div>
      )}
      {liste.map((s) => {
        const d = DURUM_ETIKET[s.durum] || { ad: s.durum, sinif: 'bg-gray-100' };
        return (
          <section key={s.id} data-siparis={s.siparis_no}
            className={`bg-white border rounded-xl p-3 space-y-2 ${vurgu === s.siparis_no ? 'border-green-400 ring-2 ring-green-200' : 'border-gray-200'}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span className="font-mono font-bold">{s.siparis_no}</span>
              <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${d.sinif}`}>{d.ad}</span>
              <span className="text-xs text-gray-500">{tarih(s.olusturma)}</span>
              <span className="text-xs text-gray-500">· {s.numaralar.length} soru</span>
            </div>
            <div data-numara-listesi className="font-mono text-xs bg-gray-50 border border-gray-200 rounded p-2 break-words select-all">
              {s.numaralar.join(', ')}
            </div>
            {s.musteri_notu && <div className="text-xs text-gray-600">Not: {s.musteri_notu}</div>}
            {s.durum === 'iptal' && s.iptal_nedeni && <div className="text-xs text-gray-600">İptal nedeni: {s.iptal_nedeni}</div>}
            <div className="flex gap-2">
              <button type="button" data-kopyala={s.siparis_no} onClick={() => kopyala(s)}
                className="px-2.5 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50">{kopyalandi === s.id ? '✓ Kopyalandı' : 'Numaraları kopyala'}</button>
              <button type="button" onClick={() => ac(s)} className="px-2.5 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50">
                {acik && acik.id === s.id ? 'Soruları gizle' : 'Soruları göster'}
              </button>
            </div>
            {acik && acik.id === s.id && (
              <div className="space-y-3 pt-2">
                {acik.sorular === null && <div className="text-xs text-gray-400">Yükleniyor…</div>}
                {acik.hata && <div className="text-xs text-red-700">{acik.hata}</div>}
                <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
                  {(acik.sorular || []).map((x) => <MusteriSoruKarti key={x.soru_no} soru={x} api={api} />)}
                </div>
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
